import SemanticPageDocument from '@/components/semantic/SemanticPageDocument';
import { getSemanticPageByPath } from '@/lib/semantic-content/pages';
import NotFound from '@/pages/NotFound';

export default function MapleOSVsChatGPT() {
  const page = getSemanticPageByPath('/mapleos-vs-chatgpt');

  return page ? <SemanticPageDocument page={page} /> : <NotFound />;
}
